module.exports = __webpack_public_path__ + "img/1701394747983-WhatsApp Image 2023-12-01 at 09.33.09.jpeg.fc81e279.webp";